<router-outlet class="root-component" [ngClass]="{'light': lightMode}"></router-outlet>